import * as React from 'react';
import { useGroundingMenuItemSkeleton_unstable } from './useGroundingMenuItemSkeleton';
import { renderGroundingMenuItemSkeleton_unstable } from './renderGroundingMenuItemSkeleton';
import { useGroundingMenuItemSkeletonStyles_unstable } from './useGroundingMenuItemSkeletonStyles.styles';
import type { GroundingMenuItemSkeletonProps } from './GroundingMenuItemSkeleton.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingMenuItemSkeleton component
export const GroundingMenuItemSkeleton: ForwardRefComponent<GroundingMenuItemSkeletonProps> = React.forwardRef(
  (props, ref) => {
    const state = useGroundingMenuItemSkeleton_unstable(props, ref);

    useGroundingMenuItemSkeletonStyles_unstable(state);
    return renderGroundingMenuItemSkeleton_unstable(state);
  },
);

GroundingMenuItemSkeleton.displayName = 'GroundingMenuItemSkeleton';
